module.exports = __webpack_public_path__ + "static/img/glove_new_brique.d655b5c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/colors/women/glove_new_brique.png
// module id = HrLr
// module chunks = 0